import type { Announcement } from '@/shared/lib/types/announcement';
import { color } from '@/shared/styles/assets/colors';
import Button from '@/shared/ui/Button';
import PrimaryAnnouncementBody from '@/shared/ui/components/PrimaryAnnouncementBody';
import { H3 } from '@/shared/ui/components/Typography';
import type { BaseDialogProps } from '@/shared/ui/DialogKit';
import { BaseDialog } from '@/shared/ui/DialogKit';
import { Campaign, CheckCircleOutlined } from '@mui/icons-material';
import { Box, DialogActions, DialogContent, Stack } from '@mui/material';

type Props = BaseDialogProps & {
  announcement: Announcement;
  handleClose: (id: string) => void;
};

const PrimaryAnnouncementDialog = ({ title, hideDialog, announcement, handleClose, ...props }: Props) => {
  return (
    <BaseDialog {...props} hideDialog={hideDialog} title={title} fullWidth maxWidth="md">
      <DialogContent>
        <Stack
          direction="row"
          sx={{
            alignItems: 'center',
            justifyContent: 'center',
            gap: 1,
            mb: 2
          }}
        >
          <Campaign sx={{ fontSize: '40px', color: color.truentityBlue[400] }} />
          {announcement.title && (
            <Box>
              <H3 sx={{ textTransform: 'capitalize', color: color.truentityBlue[800] }}>{announcement.title}</H3>
            </Box>
          )}
        </Stack>
        <PrimaryAnnouncementBody announcement={announcement} />
        <DialogActions>
          <Button startIcon={<CheckCircleOutlined />} onClick={() => handleClose(announcement.id)}>
            Ok
          </Button>
        </DialogActions>
      </DialogContent>
    </BaseDialog>
  );
};

export default PrimaryAnnouncementDialog;
